import { ActionsUnion, createAction } from 'spw-redux/types';
import { IUser } from '../user/types';
import { BillingPeriod, Organization, UpdateOrganizationInput } from './types';

export const FETCH_ORG = 'organization/FETCH_ORG';
export const FETCH_ORG_SUCCESS = 'organization/FETCH_ORG_SUCCESS';
export const GET_CURRENT_ORGANIZATION_USERS =
  'organization/GET_CURRENT_ORGANIZATION_USERS';
export const GET_CURRENT_ORGANIZATION_USERS_SUCCEEDED =
  'organization/GET_CURRENT_ORGANIZATION_USERS_SUCCEEDED';

export const UPDATE_ORGANIZATION = 'organization/UPDATE_ORGANIZATION';
export const UPDATE_ORGANIZATION_SUCCESS =
  'organization/UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILED =
  'organization/UPDATE_ORGANIZATION_FAILED';

export const FETCH_BILLING_PERIODS = 'organization/FETCH_BILLING_PERIODS';
export const FETCH_BILLING_PERIODS_SUCCESS =
  'organization/FETCH_BILLING_PERIODS_SUCCESS';
export const FETCH_BILLING_PERIODS_FAILURE =
  'organization/FETCH_BILLING_PERIODS_FAILURE';

export const FETCH_ORG_ACTIVITY_SPREADSHEET =
  'organization/FETCH_ORG_ACTIVITY_SPREADSHEET';
export const FETCH_ORG_ACTIVITY_SPREADSHEET_SUCCESS =
  'organization/FETCH_ORG_ACTIVITY_SPREADSHEET_SUCCESS';
export const FETCH_ORG_ACTIVITY_SPREADSHEET_FAILED =
  'organization/FETCH_ORG_ACTIVITY_SPREADSHEET_FAILED';

export const fetchOrg = () => createAction(FETCH_ORG);
export const fetchOrgSuccess = (organization: Organization) =>
  createAction(FETCH_ORG_SUCCESS, { organization });
export const getCurrentOrganizationUsers = () =>
  createAction(GET_CURRENT_ORGANIZATION_USERS);
export const getCurrentOrganizationUsersSucceeded = (
  organizationUsers: IUser[]
) =>
  createAction(GET_CURRENT_ORGANIZATION_USERS_SUCCEEDED, { organizationUsers });
export const updateOrganization = (
  { id, name, image }: UpdateOrganizationInput,
  onSuccess?: () => void
) => createAction(UPDATE_ORGANIZATION, { id, name, image, onSuccess });
export const updateOrganizationSuccess = (organization: Organization) =>
  createAction(UPDATE_ORGANIZATION_SUCCESS, { organization });
export const updateOrganizationFailed = () =>
  createAction(UPDATE_ORGANIZATION_FAILED);

export const fetchBillingPeriods = (orgId: number) =>
  createAction(FETCH_BILLING_PERIODS, { orgId });
export const fetchBillingPeriodsSuccess = (billingPeriods: BillingPeriod[]) =>
  createAction(FETCH_BILLING_PERIODS_SUCCESS, { billingPeriods });
export const fetchBillingPeriodsFailure = () =>
  createAction(FETCH_BILLING_PERIODS_FAILURE);

export const fetchOrgActivitySpreadsheet = (
  orgId: number,
  billingDate: string
) => createAction(FETCH_ORG_ACTIVITY_SPREADSHEET, { orgId, billingDate });
export const fetchOrgActivitySpreadsheetSuccess = () =>
  createAction(FETCH_ORG_ACTIVITY_SPREADSHEET_SUCCESS);
export const fetchOrgActivitySpreadsheetFailed = () =>
  createAction(FETCH_ORG_ACTIVITY_SPREADSHEET_FAILED);

export const actions = {
  fetchOrg,
  fetchOrgSuccess,
  getCurrentOrganizationUsers,
  getCurrentOrganizationUsersSucceeded,
  updateOrganization,
  updateOrganizationSuccess,
  updateOrganizationFailed,
  fetchBillingPeriods,
  fetchBillingPeriodsSuccess,
  fetchBillingPeriodsFailure,
  fetchOrgActivitySpreadsheet,
  fetchOrgActivitySpreadsheetSuccess,
  fetchOrgActivitySpreadsheetFailed,
};

export type Actions = ActionsUnion<typeof actions>;
